/** @owner @Appboy/ai-decisioning-experience */

export const decisioningCreativeComponentTag = "decisioning_creative_component";

export const allowedDecisioningCreativeComponentNames = ["cta", "subject_line", "image"] as const;

/**
 * Pattern for `decisioning_creative_component` Liquid tags.
 * Mirrors Ruby `DecisioningCreativeComponentTag::TAG_MARKUP_REGEX`.
 * Exported as a string so callers can construct a fresh `RegExp` per use
 * (a shared `/g` RegExp would be stateful via `lastIndex`).
 */
export const decisioningCreativeComponentTagMarkupPattern =
  "\\{%-?\\s*decisioning_creative_component\\s+([a-zA-Z0-9_]+)\\b[^%]*-?%\\}";
